
/**
 * Retrieves Search data from Algolia
 * Show a modal for Search results
 * Search action triggered on typing if search term is 3 chars or longer
 */
class Search {
  constructor() {
    this.mainsearchicons = document.querySelectorAll('.nav__primary--search');
    this.mainsearchholder = document.querySelector('.nav__search');
    this.mainsearchbox = document.getElementById('main_site_search');
    this.mainsearchresults = document.querySelector('.nav__search--resultscontainer');
    this.mobilesearchbox = document.getElementById('nav_site_search');
    this.searchresultsholder = document.querySelector('.nav__search--results');
    this.phone = document.querySelector('.nav__phone');

    this.events();
  }

  events() {
    this.mainsearchicons.forEach(icon => {
      icon.addEventListener('click', this.showMainSearch.bind(this));
    });
    this.mainsearchbox.addEventListener('keyup', this.performSiteSearch.bind(this));
    this.mobilesearchbox.addEventListener('keydown', this.performSiteSearch.bind(this));
    this.searchresultsholder.addEventListener('click', this.searchResultsActions.bind(this));
  }
  
  /**
   * Displays main search box when search icon is clicked
   * @param {Event} e 
   */
  showMainSearch(e) {
    this.mainsearchholder.classList.toggle('nav__search--show');
    e.target.classList.toggle('nav__primary--show');

    if(this.mainsearchholder.classList.contains('nav__search--show')) {
      this.mainsearchbox.focus();
    } else {
      this.mainsearchbox.blur();
    }
  }

  /**
   * Sends search request to @link Hydraulink\Controllers\SearchController
   * Populates search results element
   * @param {Event} e 
   * @returns 
   */
  performSiteSearch(e) {
    const searchval = e.target.value;
    if(searchval.length === 0) {
      this.mainsearchresults.classList.remove('nav__search--results--show');
    }
    if (searchval.length < 3) return;
    const url = '/search/search_site';
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type':'application/json',
        'x-requested-with': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        start: 0,
        search: searchval
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      let reshtml = '';
      data.forEach(res => {
        reshtml += this.resultTemplate(res);
      });
        this.mainsearchresults.innerHTML = reshtml ? reshtml : 'No results';
      if(!this.searchresultsholder.classList.contains('nav__search--results--show')) {
        this.searchresultsholder.classList.add('nav__search--results--show');
      }
    });
  }

  /**
   * @param {Object} data 
   * @returns Populated result template
   */
  resultTemplate(data) {
    return `
      <div class="search__result">
        <h3><a href="${data.Link}">${data.Title}</a></h3>
        ${data.Description}
      </div>
    `;
  } 

  /**
   * Adds actions to search result box
   * Close action when the X is clicked
   * @param {Event} e 
   */
  searchResultsActions(e) {
    // Close results
    const closeX = e.target.closest('.nav__search--close');
    // Clear results, hide results, clear search box, hide search box
    if(closeX !== null) {
      this.mainsearchresults.innerHTML = '';
      this.searchresultsholder.classList.remove('nav__search--results--show');
      this.mainsearchbox.value = '';
      this.mainsearchholder.classList.remove('nav__search--show');

      this.mainsearchicons.forEach(icon => {
        icon.classList.remove('nav__primary--show');
      })
    }
  }
}

export default Search;